import { render } from "./company-register.vue?vue&type=template&id=74d5752d&scoped=true"
import script from "./company-register.vue?vue&type=script&lang=js"
export * from "./company-register.vue?vue&type=script&lang=js"

import "./company-register.vue?vue&type=style&index=0&id=74d5752d&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d5752d"]])

export default __exports__